import { initObjectFit } from "../_object-fit";
export function lazyInit(slickSlider) {
    slickSlider.on('init', function (slick) {
        var lazy = slickSlider.find('.slick-current').next().find('mxmlazy');
        if (lazy.length) {
            lazyLoad(lazy);
        }

        var lazyPrev = slickSlider.find('.slick-current').prev().find('mxmlazy');
        if (lazyPrev.length) {
            lazyLoad(lazyPrev);
        }
    });
}

export function lazyAfter(slickSlider) {
    slickSlider.on('afterChange', function (event, slick, currentSlide) {
        var lazy = slickSlider.find('[data-slick-index="' + currentSlide + '"]').find('mxmlazy');
        if (lazy.length) {
            lazyLoad(lazy);
        }

        var lazyNext = slickSlider.find('[data-slick-index="' + currentSlide + '"]').next().find('mxmlazy');
        if (lazyNext.length) {
            lazyLoad(lazyNext);
        }
    });
}

function lazyLoad(img) {
    var attrs = img[0].attributes;
    img.replaceWith("<img id='belazy'>");
    var newImg = $('img#belazy');
    for (let i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        newImg.attr(attr.name, attr.value);
    }
    newImg.attr('id', '');

    initObjectFit();
}